import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    isAuthenticated: false,
    apolloProvider: null,
    exhibitions: [],
    artists: [],
    curators: [],
    manualDeployTriggers: 0
  },
  mutations: {
    LOGIN (state, payload) {
      state.token = payload.token
      state.user = payload.user
      state.isAuthenticated = true
      state.manualDeployTriggers = 0
    },
    LOGOUT_USER (state) {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      state.manualDeployTriggers = 0
    },
    SET_APOLLO_PROVIDER (state, provider) {
      state.apolloProvider = provider.defaultClient
    },
    SET_EXHIBITIONS (state, exhibitions) {
      state.exhibitions = exhibitions
    },
    SET_ARTISTS (state, artists) {
      state.artists = artists
    },
    SET_CURATORS (state, curators) {
      state.curators = curators
    },
    INCREMENT_MANUAL_DEPLOY_TRIGGERS (state) {
      if (state.manualDeployTriggers < 3) {
        state.manualDeployTriggers += 1
      }
    },
  },
  actions: {
    async getUser({ getters, commit }, token) {
      const apollo = getters.apolloProvider
      try {
        const result = await apollo.query({
          query: require('@/apollo/user/userByToken.gql'),
          variables: {
            token: token
          }
        })
        
        if(result.data.userByToken != null){
          commit('LOGIN', { token, user: result.data.userByToken })
          return result.data.userByToken
        }else{
          return false
        }
      } catch (err) {
        console.log("ERROR getUser", err)
        return false
      }
    },
    async login(context, token) {
      console.log(" IN STORE !");
    },
    async logout({ state, commit }, token) {
      console.log("logout ... in store");
      
      try{
        state.apolloProvider.mutate({
          mutation: require('@/apollo/logger/createLog.gql'),
          variables: {
            input: {
              eventType: "user-logged-out",
              eventExtra: `{"user": "${state.user.name}"}`,
              user: {
                id: state.user.id,
                name: state.user.name
              }
            }
          }
        })
      } catch(err) {  }
      commit('LOGOUT_USER')
    },
    async fetchInitialData({ getters, commit }) {
      const apollo = getters.apolloProvider
      try {
        // Fetch exhibitions using the correct query
        const exhibitionsResult = await apollo.query({
          query: require('@/apollo/exhibition/exhibitionsOverview.gql'),
          variables: {
            input: {
              filter: {
                includeOutsideEvents: true
              },
              limit: 10,
              skip: 0
            }
          }
        })
        commit('SET_EXHIBITIONS', exhibitionsResult.data.exhibitionsOverview.items)

        const artistsResult = await apollo.query({ query: require('@/apollo/artist/artistsMinimal.gql')})
        const artists = artistsResult.data?.artists || []
        commit('SET_ARTISTS', artists.filter(m => m.published))

        const curatorsResult = await apollo.query({ query: require('@/apollo/artist/curatorsMinimal.gql')})
        const curators = curatorsResult.data?.artists || []
        commit('SET_CURATORS', curators.filter(m => m.published))
      } catch (err) {
        console.error("Error fetching initial data:", err)
      }
    }
  },
  getters: {
    BASE_URL() {
      return process.env.VUE_APP_BASE_URL
    },
    FE_URL() {
      return process.env.VUE_APP_FE_URL
    },
    user(state) {
      return state.user
    },
    username(state) {
      return state.user?.name || ''
    },
    isEditor(state){
      return state.user?.roles?.includes('editor') || false
    },
    isAdmin(state){
      return state.user?.roles?.includes('admin') || false
    },
    isCore(state){
      return state.user?.roles?.includes('core') || false
    },
    isCurator(state){
      return state.user?.roles?.includes('curator') || false
    },
    isCrew(state){
      return state.user?.roles?.includes('crew') || false
    },
    isArtist(state){
      return state.user?.roles?.includes('artist') || false
    },
    hasBlogRole(state){
      return state.user?.roles?.includes('blog') || false
    },
    apolloProvider(state){
      return state.apolloProvider
    },
    exhibitions(state) {
      return state.exhibitions
    },
    artists(state) {
      return state.artists
    },
    curators(state) {
      return state.curators
    },
    manualDeployTriggers(state) {
      return state.manualDeployTriggers
    }
  },
  modules: {
  }
})
